import * as React from "react";

import PropTypes from "prop-types";
import { Dropdown, Icon } from "semantic-ui-react";
import { Link, useHistory, useRouteMatch } from "react-router-dom";

import styles from "./ServiceName.module.css";
import BlueButton from "../../../components/BlueButton";
import InputComponent from "../../../components/InputComponent";
import { ServiceDetailsContext } from "../../../context/ServiceDetailsContext";

import { useStoreState } from "../../../hooks";

import { ServiceSteps } from "../../../components/Steps";

import { FaSpinner } from "react-icons/fa";

const { useContext, useState } = React;

const stepsNotDone = [
  {
    id: 1,
    stepsName: "Location",
  },
  {
    id: 2,
    stepsName: "Postal address",
  },
  {
    id: 3,
    stepsName: "Contact details",
  },
  {
    id: 4,
    stepsName: "Providers",
  },
  {
    id: 5,
    stepsName: "Supervisor",
  },
  {
    id: 6,
    stepsName: "Leader",
  },
  {
    id: 7,
    stepsName: "Operating hours",
  },
  {
    id: 8,
    stepsName: "Additional info",
  },
  {
    id: 9,
    stepsName: "Educators",
  },
  {
    id: 10,
    stepsName: "QIP submission",
  },
  {
    id: 11,
    stepsName: "Philosophy",
  },
  {
    id: 12,
    stepsName: "Service logo",
  },
];

const serviceTypeOption = [
  {
    key: "1",
    value: "Long Daycare",
    text: "Long Daycare",
  },
  {
    key: "2",
    value: "Family Daycare",
    text: "Family Daycare",
  },
  {
    key: "3",
    value: "Pre-school",
    text: "Pre-school",
  },
  {
    key: "4",
    value: "OOSH",
    text: "OOSH",
  },
];

function ServiceName({ onNextStep, onSaveStep, onSkipServiceDetails }) {
  const history = useHistory();
  const match = useRouteMatch();

  const { saveLoading, serviceDetailsState, changeInputDispatch } = useContext(
    ServiceDetailsContext
  );

  const isLoggedIn = useStoreState((state) => state.authStore.isLoggedIn);

  const [fieldChecked, setFieldChecked] = useState(false);

  const onSave = async () => {
    setFieldChecked(true);

    if (
      !serviceDetailsState.validation.name ||
      !serviceDetailsState.validation.approvalNumber
    ) {
      return;
    }
    await onSaveStep();

    await onNextStep();

    history.push(
      `${match.path
        .split("/")
        .slice(0, match.path.split("/").length - 1)
        .join("/")}/1`
    );
    // history.push(
    //   `${match.path
    //     .split("/")
    //     .slice(0, match.path.split("/").length - 1)
    //     .join("/")}/service-details/service-name`
    // );
    // } else alert("Please fill all required fields.");
  };

  return (
    <div className={styles.mainContainer}>
      {isLoggedIn && (
        <>
          <div className={styles.headerContainer}>
            <h1>Complete your service details</h1>
            <p>
              Please fill out all missing fields marked with an ‘
              <span className={styles.required}>*</span>’
            </p>
          </div>
        </>
      )}
      <div className={styles.mainCard}>
        <div className={styles.cardContent}>
          <h1 className={styles.headerText}>Service name</h1>

          <text className={styles.descriptionText}>
            Please update the below fields where applicable.
          </text>

          <div className={styles.inputRow}>
            <div className={styles.inputColumn}>
              <InputComponent
                fieldName="name"
                label="Service name"
                type="text"
                required
                showNotFilled={fieldChecked}
                isInvalid={!serviceDetailsState.validation.name}
                inputValue={serviceDetailsState.input.name}
                setInputValue={changeInputDispatch}
              />
            </div>

            <div className={styles.inputColumn}>
              <InputComponent
                fieldName="approvalNumber"
                label="Service approval number"
                type="text"
                required
                showNotFilled={fieldChecked}
                isInvalid={!serviceDetailsState.validation.approvalNumber}
                inputValue={serviceDetailsState.input.approvalNumber}
                setInputValue={changeInputDispatch}
              />

              <div className={styles.dropdownGroup}>
                <text className={styles.dropdownName}>
                  Service type <span className={styles.required}>*</span>
                </text>

                <Dropdown
                  className={styles.dropdownBox}
                  fluid
                  selection
                  placeholder="Choose"
                  options={serviceTypeOption}
                  defaultValue={
                    serviceTypeOption[
                      serviceDetailsState.input.serviceCatId - 1
                    ].value
                  }
                  onChange={(e, data) => {
                    changeInputDispatch(
                      "serviceCatId",
                      serviceTypeOption.filter(
                        (option) => option.value === data.value
                      )[0].key
                    );
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.buttonGroup}>
            <BlueButton // buttonText="Save step"
              buttonText={
                saveLoading ? (
                  <div className={`flex justify-center items-center`}>
                    <FaSpinner className={`animate-spin`} />
                    <span className={`block pl-2`}>Save step</span>
                  </div>
                ) : (
                  <> Save step</>
                )
              }
              onClick={onSave}
            />

            <button
              className={styles.buttonNextStep}
              onClick={() =>
                history.push(
                  `${match.path
                    .split("/")
                    .slice(0, match.path.split("/").length - 1)
                    .join("/")}/1`
                )
              }
            >
              Next step
            </button>
          </div>

          <div className={styles.buttonStep}>
            {/* <button className={styles.buttonStepDisabled}>
              <Icon name="angle left" />
              Back a step
            </button> */}

            <button
              className={styles.buttonFinishLater}
              onClick={onSkipServiceDetails}
            >
              Finish Later
              <Icon name="angle double right" />
            </button>
          </div>
        </div>

        <div className={styles.stepsColumn}>
          <ServiceSteps route={match.path} />
          {/* <div className={styles.CurrentItemContainer}>
            <div className={styles.stepItemCurrent}>
              <div className={styles.stepItemFillDone} />
            </div>

            <text className={styles.stepItemCurrentText}>Service name</text>
          </div>

          {stepsNotDone.map((steps) => (
            <div key={steps.id} className={styles.stepItemContainer}>
              <Link
                className={styles.stepItemCurrentText}
                to={`${match.path
                  .split("/")
                  .slice(0, match.path.split("/").length - 1)
                  .join("/")}/${steps.id}`}
              >
                <div className={styles.stepItemIndicatorContainer}>
                  <div className={styles.stepItemFill} />
                </div>
                <text>{steps.stepsName}</text>
              </Link>
            </div>
          ))} */}
        </div>
      </div>
    </div>
  );
}

ServiceName.propTypes = {
  onNextStep: PropTypes.func,
  onSkipStep: PropTypes.func,
  onSaveStep: PropTypes.func,
  onSkipServiceDetails: PropTypes.func,
};

export default ServiceName;
